import { StationActionTypes, showSnackbar } from '../actions/station';

export interface CreateStationState {
  loading: boolean;
  error: string;
  docId: string;
  shouldShowSnackbar: boolean;
}

const initialState: CreateStationState = {
  loading: false,
  error: '',
  docId: '',
  shouldShowSnackbar: false,
};

export default (state = initialState, action: StationActionTypes) => {
  switch (action.type) {
    case 'CREATE_STATION_LOADING':
      return {
        ...state,
        loading: true,
        docId: '',
        error: '',
        shouldShowSnackbar: false,
      };
    case 'CREATE_STATION_SUCCESS':
      return {
        ...state,
        loading: false,
        docId: action.payload.docId,
        error: '',
        shouldShowSnackbar: true,
      };
    case 'CREATE_STATION_FAILED':
      return {
        ...state,
        loading: false,
        docId: '',
        error: action.payload.error,
        shouldShowSnackbar: true,
      };
    case 'SHOW_SNACKBAR':
      return {
        ...state,
        shouldShowSnackbar: false,
      };
    default:
      return state;
  }
};
